import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

/** Applies the environment branding and starts the app. Shared by every entry point. */
export function bootstrapStatusNow(): void {
  const favicon = document.querySelector<HTMLLinkElement>(
    '#environment-favicon'
  );
  if (favicon) {
    favicon.href = environment.branding.faviconHref;
  }

  const manifest = document.querySelector<HTMLLinkElement>(
    '#environment-manifest'
  );
  if (manifest) {
    manifest.href = environment.branding.manifestHref;
  }

  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}
